<template>
  <div>
    <card class="card" title="Statistics">
      <!-- Content Part -->
      <div v-if="Object.keys(companies_statistics).length === 0" class="card__content">Loading...</div>
      <div v-else class="card__content">
        <div v-for="companies_statistic in companies_statistics" class="row">
          <div class="col-xl-12">
            <h4>{{ companies_statistic.name }}</h4>
          </div>
          <div v-for="(stat, index) in companies_statistic.stats" v-bind:key="index" class="col-md-2">
            <div v-if="stat.title">
              {{ stat.title }}
              <span v-if="stat.total_questions"> - {{ stat.answered_questions }} / {{ stat.total_questions }} </span>
              <div>
                <p class="stat_value">{{ stat.value }}</p>
              </div>
            </div>
            <div v-else>
              {{ titles[index] }}
              <div>
                <p class="stat_value">{{ stat }}</p>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>

      <!-- End Content Part -->
    </card>
  </div>
</template>

<script>
export default {
  name: 'CompaniesStatistics',
  props: {
    companies_statistics: {},
    loading: false,
  },
  data: function () {
    return {
      titles: {
        current_certificate: 'Current certificate',
        total_certification_score: 'Total Score',
        progress_to_next_certification: 'Progress 2 next certificate (%)',
      },
    };
  },
};
</script>

<style>
.stat_value {
  font-size: 2em;
}
</style>
